import { generateCrudApi } from "helpers/crudGeneratorExtend";

export const stocksApi = generateCrudApi({
  name: "stocks",
});
